export default __webpack_public_path__ + "static/media/job_offer20_xl.87886b27.jpg";